import React from "react";
import { Stack } from "@bookingcom/bui-react";
import { Breakdown } from "./Breakdown";
import { ViewPriceDetails } from "./banners/ViewPriceDetails";
import {
  useUnifiedPriceBreakdownPostBookingController,
  type UnifiedPriceBreakdownPostBookingControllerProps
} from "./useUnifiedPriceBreakdown.PostBooking.controller";
import { UnifiedPriceBreakdownPostBooking } from "./UnifiedPriceBreakdown.PostBooking";
import useEvents from "hooks/useEvents";

export type UnifiedPriceBreakdownPostBookingSummaryProps = UnifiedPriceBreakdownPostBookingControllerProps;

export function UnifiedPriceBreakdownPostBookingSummary(props: UnifiedPriceBreakdownPostBookingSummaryProps) {
  const { unifiedPriceBreakdown, isHungaryDepartingRyanAir, isWithDiscount, addedItems, routeName, expandedByDefault } =
    useUnifiedPriceBreakdownPostBookingController(props);

  const { grumble } = useEvents();

  if (!unifiedPriceBreakdown) {
    grumble("unifiedPriceBreakdown object unavailable", { controller: "PostBookingSummary", routeName });
    return null;
  }

  return (
    <Stack gap={4}>
      <Breakdown
        {...unifiedPriceBreakdown}
        isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
        isSummary={true}
        addedItems={addedItems}
        expandedByDefault={expandedByDefault}
        isWithDiscount={isWithDiscount} // flights_unified_price_breakdown_pb
      />
      <ViewPriceDetails>
        <UnifiedPriceBreakdownPostBooking {...props} />
      </ViewPriceDetails>
    </Stack>
  );
}
